import request from '@/utils/request'
import JSONBig from 'json-bigint'

// 用 storeAsString 解析后端的雪花 ID（Long），避免 JS Number 精度丢失
const JSONBigString = JSONBig({ storeAsString: true })
const bigNumberTransform = [
  function (data) {
    if (typeof data !== 'string' || !data) return data
    try {
      return JSONBigString.parse(data)
    } catch (e) {
      return data
    }
  }
]

/**
 * 提交学校认证
 *
 * 身份证正反面必传，学生证与校园卡二选一。提交后进入人工审核，
 * 通过后昵称旁展示学校认证角标；用户切换绑定学校后角标自动失效，需重新认证。
 *
 * @param {Object} data
 * @param {String} data.realName        真实姓名
 * @param {String} data.idCardNo        身份证号（服务端加密存储，不会原样返回）
 * @param {String} data.idCardFrontUrl  身份证正面(人像面)图片URL
 * @param {String} data.idCardBackUrl   身份证反面(国徽面)图片URL
 * @param {Number} data.certType        学生身份证明类型 1:学生证 2:校园卡
 * @param {String} data.certImageUrl    学生证/校园卡图片URL
 */
export function submitCampusAuth (data) {
  return request({
    url: '/v1/campusAuth/submit',
    method: 'post',
    data,
    transformResponse: bigNumberTransform
  })
}

/**
 * 查询我的学校认证信息
 *
 * data 为 null 表示从未提交过；否则含 status（0待审核 1已通过 2已驳回 3已失效 4已撤回）、
 * canSubmit（是否可提交/重新提交）、canWithdraw（是否可撤回）、reviewRemark（驳回理由）等字段。
 */
export function getMyCampusAuth () {
  return request({
    url: '/v1/campusAuth/my',
    method: 'get',
    transformResponse: bigNumberTransform
  })
}

/**
 * 撤回学校认证申请
 *
 * 仅「审核中」的申请可撤回。撤回后不再占用申请名额，可修改材料后重新提交。
 * id 走 params（服务端是 @RequestParam 接收，与「取消校园大使报名」一致）。
 *
 * @param {Number|String} id 认证记录ID
 */
export function withdrawCampusAuth (id) {
  return request({
    url: '/v1/campusAuth/withdraw',
    method: 'post',
    params: { id }
  })
}
